import {useState} from 'react'

import PropTypes from 'prop-types'

import AtomSpinner from '@s-ui/react-atom-spinner'
import {useSuiContext} from '@s-ui/react-context'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import BaseDrawer from '../BaseDrawer/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-carfaxDrawer`

const CarfaxDrawer = ({onClose, reportUrl}) => {
  const {i18n} = useSuiContext()
  const title = i18n.t('CARFAX.DRAWER_TITLE')

  const [isLoading, setIsLoading] = useState(true)

  return (
    <BaseDrawer onClose={onClose} title={title}>
      <div className={`${BASE_CLASS}-iframeWrapper`}>
        {isLoading && (
          <div className={`${BASE_CLASS}-spinner`}>
            <AtomSpinner />
          </div>
        )}
        <iframe className={`${BASE_CLASS}-iframe`} onLoad={() => setIsLoading(false)} src={reportUrl} title={title} />
      </div>
    </BaseDrawer>
  )
}

CarfaxDrawer.displayName = 'CarfaxDrawer'

CarfaxDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  reportUrl: PropTypes.string.isRequired
}

export default CarfaxDrawer
